/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useOrgRoleData from '../../../state/orgRole/UseOrgRoleData';

const useOrgRoleMultiSelect = () => {
  const { orgRoleState, getOrgRoleDataByRoleGroupId } = useOrgRoleData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (orgRoleState.isArrayLoading === false && orgRoleState.isArrayLoaded === false) {
      getOrgRoleDataByRoleGroupId(59); // 59 = USAS Athletes
    } else if (orgRoleState.isArrayLoading === false && orgRoleState.isArrayLoaded === true) {
      const orgRoleOptions = [];

      for (const orgRole of orgRoleState.arrayData) {
        if (orgRole.orgRoleId.length > 0 && orgRole.parentId !== null) {
          orgRoleOptions.push({ id: orgRole.orgRoleId, name: orgRole.orgRoleName });
        }
      }

      setOptions(orgRoleOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgRoleState]);

  return {
    orgRoleState,
    options
  };
};

export default useOrgRoleMultiSelect;